<div class="w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Recharges {{ refillLabel }}</div>
</div>
<!---------------------------------------------------- 1 REFILL / PASS Choice--------------------------------------------->
@if (step == 1) {
    <div class="row">
        @if (line.offer.offer_category !== prepaidOfferCategory) {
            <div class="col-2"></div>
        }
        <div class="col-4 text-center" (click)="setChoice(refillChoice)">
            <div class="card text-center cursor-pointer active-card">
                <div class="card-block">
                    <img src="../assets/images/icons/procedures/msisdn/refill_or_pass.png">
                </div>
                <div class="row-100 text-center p-1">
                    <h3 class="procedure-card_title">Wallet</h3>
                </div>
            </div>
        </div>
        <div class="col-4 text-center" (click)="setChoice(passChoice)">
            <div class="card text-center cursor-pointer active-card">
                <div class="card-block">
                    <img src="../assets/images/icons/procedures/msisdn/refill_or_pass.png">
                </div>
                <div class="row-100 text-center p-1">
                    <h3 class="procedure-card_title">Options</h3>
                </div>
            </div>
        </div>
        @if (line.offer.offer_category == prepaidOfferCategory) {
            <div class="col-4 text-center" (click)="setChoice(offerChoice)">
                <div class="card text-center cursor-pointer active-card">
                    <div class="card-block">
                        <img src="../assets/images/icons/procedures/msisdn/refill_or_pass.png">
                    </div>
                    <div class="row-100 text-center p-1">
                        <h3 class="procedure-card_title">Forfait</h3>
                    </div>
                </div>
            </div>
        } @else {
            <div class="col-2"></div>
        }
        @if (rateLimitErrorMessage) {
            <div class="w-100 error-message text-center">{{ rateLimitErrorMessage }}</div>
        }
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_btn level_2 column" (click)="cancel()">Annuler<span></span></button>
            </div>
        </div>
    </div>
}
<!---------------------------------------------------- 2 Options Choice --------------------------------------------->
@if (step == 2) {
    <div class="row ml-3">
        @if (choice == refillChoice) {
            <div>
                <div class="bold-text">Choix de recharge:</div>
                <p>Ce montant sera alimenté sur votre wallet et vous permettra d'acheter des options, de renouveler
                    votre forfait
                    bloqué, de passer les communications hors forfait etc.</p>
                <div class="align-items-start mt-3 bills-list">
                    @for (option of options; track option; let index = $index) {
                        <div class="item">
                            <input
                                    type="checkbox"
                                    [checked]="isChecked(option)"
                                    [value]="option.option.option_id"
                                    [id]="'option_' + option.option.option_id"
                                    (click)="setCheckedOption($event, option)"
                            />
                            <label [for]="'option_' + option.option.option_id "
                                   class="form-check-label">{{ option.option.label_ec }}</label>
                        </div>
                    }
                </div>
            </div>
        }
        @if (choice == passChoice) {
            @if (options.length == 0) {
                <div class="error-message text-center" style="margin-left: -10px;">La liste des options est vide.</div>
            } @else {
                <div>
                    <div class="bold-text">Choix des options:</div>
                    <div class="align-items-start mt-3 bills-list">
                        @for (option of options; track option; let index = $index) {
                            @if (
                                option.option.type_france !== 'promo_algerie' ||
                                (
                                    option.option.type_france == 'promo_algerie' &&
                                    displayPromoAlgeria
                                )
                                    ) {
                                <div class="item">
                                    <input
                                            type="checkbox"
                                            [checked]="isChecked(option)"
                                            [value]="option.option.option_id"
                                            [id]="'option_' + option.option.option_id"
                                            (click)="setCheckedOption($event, option)"
                                    />
                                    <label
                                            [for]="'option_' + option.option.option_id "
                                            class="form-check-label">{{ option.option.label_ec }}
                                        <strong>[{{ option.option.in_sale_ttc.toFixed(2) }}€]</strong>
                                    </label>
                                </div>
                            }
                        }
                    </div>
                    <div class="align-items-start mt-3 bills-list">
                        <p><strong>Option Internationale 10€, </strong> valable 1 mois depuis la France métropolitaine, vous
                            permet d'appeler vers les fixes et mobiles de plus <span class="href"
                                                                                     (click)="displayCountries = !displayCountries">60 destinations.</span>
                        </p>
                        <p><strong> Option Internationale 20€, </strong> valable 1 mois depuis la France métropolitaine,
                            vous permet d'appeler vers les fixes et mobiles de plus 60 destinations.</p>
                        <p><strong> Option USA 10 </strong> : Appels & SMS illimités depuis les Etats-Unis vers la France
                            métropolitaine et les Etats-Unis; 20 Go d’Internet Mobile depuis les Etats-Unis</p>
                        <p><strong> Pass Algérie 200 </strong> : 200 minutes incluses depuis la France métropolitaine vers les mobiles des opérateurs algériens Ooredoo et Mobilis (numéros commençant par 2136 et 2135). Pour un usage uniquement personnel et non lucratif. Compatible avec les kits SFR Discover en cours de validité.</p>
                        <p><strong> Pass illimité Algérie </strong> : Appels illimités depuis la France métropolitaine vers les mobiles des opérateurs algériens Ooredoo et Mobilis (numéros commençant par 2136 et 2135). Pour un usage uniquement personnel et non lucratif. Compatible avec les forfaits sans engagement SFR Discover en cours de validité.</p>
                    </div>
                    @if (displayCountries) {
                        <div class="row">
                            <div class="col-4">
                                @for (city of ['Algérie', 'Arabie Saoudite', 'Argentine', 'Arménie', 'Bangladesh', 'Bénin', 'Bénin MTN', 'Brésil', 'Burkina Faso', 'Cambodge', 'Cameroun', 'Cameroun MTN', 'Cap Vert', 'Centrafrique', 'Chili', 'Colombie', 'Comores', 'Congo', 'RD Congo', 'Côte d\'Ivoire', 'Côte d\'Ivoire MTN']; track city; let index = $index) {
                                    <p><strong>{{ (index + 1) + '- ' + city }}</strong></p>
                                }
                            </div>
                            <div class="col-4">
                                @for (city of ['Côte d\'Ivoire Orange', 'Croatie', 'Egypte', 'Emirats Arabes Unis', 'Equateur', 'Gabon', 'Rep. de Géorgie', 'Ghana', 'Guinée Rep', 'Haïti', 'Inde', 'Indonésie', 'Jordanie', 'Kenya', 'Liban', 'Liberia', 'Libye', 'Macédoine', 'Mali', 'Mali Orange', 'Maroc']; let index = $index; track city) {
                                    <p><strong>{{ (index + 22) + '- ' + city }}</strong></p>
                                }
                            </div>
                            <div class="col-4">
                                @for (city of ['Mauritanie', 'Mexique', 'Moldavie', 'Niger', 'Nigeria', 'Nigeria MTN', 'Pakistan', 'Pérou', 'Philippines', 'Russie', 'Sénégal', 'Sénégal Orange', 'Serbie', 'Soudan', 'Sri Lanka', 'Syrie', 'Thaïlande', 'Togo', 'Tunisie', 'Venezuela', 'Vietnam']; track city; let index = $index) {
                                    <p><strong>{{ (index + 44) + '- ' + city }}</strong></p>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        }
        @if (choice == offerChoice) {
            <div>
                <div class="bold-text">Choix de forfait sans engagement / valable 1 mois:</div>
                <div class="align-items-start mt-3 bills-list">
                    @for (offer of offers; track offer; let index = $index) {
                        <div class="item">
                            <input
                                    type="checkbox"
                                    [checked]="isChecked(offer)"
                                    [value]="offer.offer_id"
                                    [id]="'offer_' + offer.offer_id"
                                    (click)="setCheckedOption($event, offer)"
                            />
                            <label [for]="'offer_' + offer.offer_id " class="form-check-label">{{ offer.label }}<strong>[{{ offer.base_price_ttc }}
                                €]</strong></label>
                        </div>
                    }
                </div>
            </div>
        }
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_btn level_2 column mr-3" (click)="setStep(1)">Retour<span></span>
                </button>
                @if (checkedItems.length > 0) {
                    <button type="button" class="cta_btn level_2 column" (click)="setStep(3)">Suivant<span></span>
                    </button>
                }
            </div>
        </div>
    </div>
}
<!---------------------------------------------------- 3 Payment --------------------------------------------->
@if (step == 3) {
    <div class="ml-3">
        <div class="radio-group mb-2">
            @if (!isEmpty(customer.iban) || !isEmpty(selectedCard)) {
                <div class="bold-text">Choix du moyen de paiement</div>
            }
            @if (!isEmpty(customer.iban) && choice !== refillChoice) {
                <input type="radio" id="choice1" name="payment" value="iban_payment"
                       [checked]="selectedPaymentMethod == 'iban_payment'"
                       (click)="setSelectedPaymentMethod('iban_payment')">
            }
            @if (!isEmpty(customer.iban) && choice !== refillChoice) {
                <label for="choice1">Prélèvement bancaire</label>
            }
            @if (walletValue >= paymentDetailsInterface.amount && choice !== refillChoice) {
                <input type="radio" id="choice4" name="payment" value="cus_wallet_payment"
                       [checked]="selectedPaymentMethod == 'cus_wallet_payment'"
                       (click)="setSelectedPaymentMethod('cus_wallet_payment')">
            }
            @if (walletValue >= paymentDetailsInterface.amount && choice !== refillChoice) {
                <label for="choice4">Wallet</label>
            }
            @if (cards.length > 0) {
                <input type="radio" id="choice2" name="payment" value="cb_payment_recurrent"
                       [checked]="selectedPaymentMethod == 'cb_payment_recurrent'"
                       (click)="setSelectedPaymentMethod('cb_payment_recurrent')">
            }
            @if (cards.length > 0) {
                <label for="choice2">Mon CB</label>
            }
            <input type="radio" id="choice3" name="payment" value="cb_payment_one_shot"
                   [checked]="selectedPaymentMethod == 'cb_payment_one_shot'"
                   (click)="setSelectedPaymentMethod('cb_payment_one_shot')">
            <label for="choice3">Autre CB</label>
        </div>
        <div class="mb-3"><span class="bold-text">Montant à payer:</span> {{ paymentDetailsInterface.amount }}€</div>
        @if (selectedPaymentMethod == 'cus_wallet_payment') {
            <div class="mb-3"><span class="bold-text">Paiement par Wallet:</span> {{ paymentDetailsInterface.amount }}€
            </div>
        }
        @if (selectedPaymentMethod == 'cb_payment_recurrent') {
            <div class="mb-3 form-group"><span class="bold-text">Paiement par CB:</span>
                <select name="card" class="custom-select mt-3" (change)="setSelectedCard($event)">
                    @for (card of cards; track card) {
                        <option [value]="card.externalId"
                                [selected]="card.externalId == selectedCard.externalId">{{ card.cardNumber + ' - ' + getCardCreationDate(card.createdAt) }}
                        </option>
                    }
                </select>
            </div>
        }
        @if (selectedPaymentMethod == 'iban_payment') {
            <div class="mb-3"><span class="bold-text">Paiement par prélèvement bancaire:</span> {{ this.customer.iban }}
            </div>
        }
        @if (selectedPaymentMethod == 'cb_payment_one_shot') {
            <app-payment-form [paymentDetailsInterface]="paymentDetailsInterface"></app-payment-form>
        }
        @if (['cb_payment_recurrent', 'iban_payment', 'cus_wallet_payment'].indexOf(selectedPaymentMethod) !== -1) {
            <div class="row w-100 pt-3 text-center">
                <div class="col-12 w-100 cta_container">
                    <button type="button" class="cta_btn level_2 column mr-3" (click)="setStep(2)">Retour<span></span>
                    </button>
                    <button type="button" class="cta_btn level_2 column mr-3" (click)="cancel()">Annuler<span></span>
                    </button>
                    <button type="button" class="cta_btn level_2 column" (click)="save()">Enregistrer<span></span>
                    </button>
                </div>
            </div>
        }
    </div>
}
